import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'sb-toggle-switch',
  templateUrl: './sb-toggle-switch.component.html',
  styleUrls: ['./sb-toggle-switch.component.scss'],
  standalone: false,
})
export class SbToggleSwitchComponent implements OnInit {
  @Input()
  model: boolean;

  @Input()
  disabled: boolean;

  @Output()
  modelChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  private get _model(): boolean {
    return this.model;
  }

  private set _model(val: boolean) {
    this.model = val;
    this.modelChange.emit(this.model);
  }

  @Input()
  onText: string;

  @Input()
  offText: string;

  constructor() {
    this.onText = 'Yes';
    this.offText = 'No';
  }

  toggle() {
    if (!this.disabled) {
      this._model = !this._model;
    }
  }

  ngOnInit() {
    if (!this.onText) {
      this.onText = 'Yes';
    }
    if (!this.offText) {
      this.offText = 'No';
    }
  }

  getClassSwitch() {
    if (this.model) {
      return 'sb-switch-on';
    } else {
      return 'sb-switch-off';
    }
  }
}
